<template>
    <div class="dcc">
        <h3 class="dcc__heading">{{ heading }}</h3>
        <div class="dcc_image">
            <span>{{ t(`diamondProperties.shape.${shape}`) }}</span>
            <img :src="image.img" :alt="image.label" height="14" />
        </div>
        <div class="dcc__properties">
            <dl>
                <dt>{{ t("components.carat") }}:</dt>
                <dd
                    :class="{
                        dcc_properties__highlighted:
                            highlightAttribute === 'carat'
                    }"
                >
                    {{ carat }}
                    {{ t("components.ct") }}
                </dd>

                <dt>{{ t("components.clarity") }}:</dt>
                <dd
                    :class="{
                        dcc_properties__highlighted:
                            highlightAttribute === 'clarity'
                    }"
                >
                    {{ clarity }}
                </dd>

                <dt>{{ t("components.color") }}:</dt>
                <dd
                    :class="{
                        dcc_properties__highlighted:
                            highlightAttribute === 'color'
                    }"
                >
                    {{ color }}
                </dd>

                <dt>{{ t("components.cut") }}:</dt>
                <dd
                    :class="{
                        dcc_properties__highlighted:
                            highlightAttribute === 'cut'
                    }"
                >
                    {{ cut ? t(`diamondProperties.cut.${cut}`) : "-" }}
                </dd>

                <!--
                <dt>ID:</dt>
                <dd
                    :class="{
                        dcc_properties__highlighted:
                            highlightAttribute === 'productId'
                    }"
                >
                    {{ productId }}
                </dd>
                -->
            </dl>
        </div>
        <div class="dcc__price">
            {{ priceHumanReadable }}
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import { Diamond } from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import { useI18n } from "vue-i18n";
import useDiamondShapeImageMap from "@/composables/useDiamondShapeImageMap";

export default defineComponent({
    name: "ComparableDiamondCard",
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        },
        heading: {
            type: String,
            required: true
        },
        highlightAttribute: {
            type: String,
            required: false,
            default: null
        }
    },
    setup(props) {
        const {
            cut,
            shape,
            carat,
            clarity,
            color,
            priceHumanReadable,
            productId
        } = useDiamondProperties(computed(() => props.diamond));

        const diamondShapeImageMap = useDiamondShapeImageMap();
        const image = computed(() => diamondShapeImageMap[props.diamond.shape]);

        return {
            ...useI18n(),
            cut,
            shape,
            carat,
            clarity,
            color,
            priceHumanReadable,
            productId,
            image
        };
    }
});
</script>
